export default "__VITE_ASSET__d53127b1__"